import { staticComponentValueConverter } from '../StaticComponentValues';
import InfiniteSlider from '../../DnDInfiniteSlider/InfiniteSlider';
import React, { useEffect, useMemo, useState } from 'react';
import { HexToHueConverter } from '../../../../../../../helper/ColorToHueConverter';
import store from '../../../../../../../redux/store';

import { useDispatch } from 'react-redux';
import themeSlice from '../../../../../../../redux/themeSlice';
import { translate } from '../../../../../../../utils/language';
import { useSelector } from 'react-redux';
import { getProductWithCategoryId } from '../../../../../../../helper/ThemeRequests';
import { ChildComponents } from '../../DnDChildComponents';

const createImageUrl = (imageId, merchantId) => {
  return imageId ? `https://cdn.myikas.com/images/${merchantId}/${imageId}/image_540.webp` : null;
};
function BaseFilteredProductSlider({ item, Product, productWidth, isCentered, activeBigger, imageWidth }) {
  const staticValues = useSelector(state => state.themeSlice?.staticValues);

  const [selectedTopId, setSelectedTopId] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState(null);

  // const getLevelStyles = level => {
  //   switch (level + 1) {
  //     case 1:
  //       return {
  //         textSize: customization?.levelOneTextSize,
  //         textColor: customization?.levelOneTextColor,
  //         textWeight: customization?.levelOneTextWeight,
  //       };
  //     case 2:
  //       return {
  //         textSize: customization?.levelTwoTextSize,
  //         textColor: customization?.levelTwoTextColor,
  //         textWeight: customization?.levelTwoTextWeight,
  //       };
  //     case 3:
  //       return {
  //         textSize: customization?.levelThreeTextSize,
  //         textColor: customization?.levelThreeTextColor,
  //         textWeight: customization?.levelThreeTextWeight,
  //       };
  //     default:
  //       return {
  //         textSize: customization?.levelFourAndOthersTextSize,
  //         textColor: customization?.levelFourAndOthersTextColor,
  //         textWeight: customization?.levelFourAndOthersTextWeight,
  //       };
  //   }
  // };

  useEffect(() => {
    if (customization?.items?.length > 0) {
      const firstTop = customization.items[0];
      setSelectedTopId(firstTop.id);
      const firstChild = firstTop.children?.[0];
      if (firstChild) {
        setSelectedCategoryId(firstChild.categoryId);
      }
    }
  }, []);

  const collectionHashMap = useSelector(state => state.themeSlice?.collectionHashMap);
  const merchantId = store.getState()?.myUserSlice?.merchantId;
  const [dynamicImages, setDynamicImages] = useState([]);
  const dispatch = useDispatch();

  const dynamicImage = item?.data?.dynamicImages?.[0];
  const isDynamic = item?.data?.isDynamic;

  const images = item?.data?.images || [];
  const [reset, forceReset] = useState(false);
  const min = item?.variantData?.minImage;
  const customization = staticComponentValueConverter(item?.customization);
  const heartIconFilter = useMemo(
    () => HexToHueConverter(customization?.heartIconColor),
    [customization?.heartIconColor],
  );
  const cartIconFilter = useMemo(() => HexToHueConverter(customization?.cartIconColor), [customization?.cartIconColor]);
  const discountIconFilter = useMemo(
    () => HexToHueConverter(customization?.discountIconColor),
    [customization?.discountIconColor],
  );

  useEffect(() => {
    forceReset(state => !state);
  }, [item?.customization?.containerPadding]);

  const renderImages = (isDynamic ? dynamicImages : images).map((imgObj, index) => (
    <Product
      productWidth={productWidth}
      customization={customization}
      imgObj={imgObj}
      key={index}
      iconFilters={{ heartIconFilter, cartIconFilter, discountIconFilter }}
    />
  ));

  const getProducts = async (sourceId, limit, type) => {
    const baseDynamicImages = Array.from({ length: limit }, (_, index) => ({
      image: {
        src: process.env.REACT_APP_PRELOADER_IMAGE,
        text: '',
      },
      pointTo: {
        pointTo: '',
        pointToType: '',
      },
      id: '',
      useCustomImage: true,
      useCustomText: true,
    }));
    const selectedHash = collectionHashMap[sourceId + '_' + limit + '_' + type];
    if (selectedHash) {
      if (!(selectedHash?.length > 0)) {
        setDynamicImages(
          baseDynamicImages?.map(e => ({
            ...e,
            image: { src: process.env.REACT_APP_DEFAULT_IMAGE, text: translate('exampleProduct') },
          })),
        );
        return;
      }
      return setDynamicImages(selectedHash);
    }
    setDynamicImages(baseDynamicImages);

    const productData = await getProductWithCategoryId({ sourceId, limit, type });
    if (!productData || !(productData?.results?.length > 0)) {
      setDynamicImages(
        baseDynamicImages?.map(e => ({
          ...e,
          image: { src: process.env.REACT_APP_DEFAULT_IMAGE, text: translate('exampleProduct') },
        })),
      );
      return;
    }

    const newDynamicImages = productData?.results?.map((product, index) => {
      const image = createImageUrl(product?.variants?.[0]?.images?.[0]?.id, merchantId);
      const name = product?.name;
      return {
        image: {
          src: image,
          text: name,
        },
        pointTo: {
          pointTo: '',
          pointToType: '',
        },
        id: product?.id,
        useCustomImage: true,
        useCustomText: true,
      };
    });
    const newHash = {};
    newHash[sourceId + '_' + limit + '_' + type] = newDynamicImages;
    dispatch(themeSlice.actions.setCollectionHashMap(newHash));

    setDynamicImages(newDynamicImages);
  };
  useEffect(() => {
    if (selectedCategoryId) {
      getProducts(selectedCategoryId, 10, 'category');
    }
  }, [selectedCategoryId]);
  // useEffect(() => {
  //   if (dynamicImage && isDynamic) {
  //     getProducts(dynamicImage?.pointTo?.pointTo, dynamicImage?.dynamicLimit, dynamicImage?.pointTo?.pointToType);
  //   }
  // }, [dynamicImage?.pointTo?.pointTo, dynamicImage?.dynamicLimit]);

  return (
    <>
      {customization?.items?.length > 0 && (
        <div
          style={{
            margin: customization?.filteredMenuContainerPadding,
            backgroundColor: customization?.filteredMenuBackgroundColor,
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: customization?.filteredMenuBorderColor,
            borderRadius: customization?.filteredMenuBorderRadius,
            overflow: 'hidden',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'center', gap: 10, padding: '10px' }}>
            {customization.items.map(group => (
              <div
                key={group.id}
                onClick={() => {
                  setSelectedTopId(group.id);
                }}
                style={{
                  cursor: 'pointer',
                  fontSize: customization?.levelOneTextSize,
                  fontWeight: customization?.levelOneTextWeight,
                  border: `${customization?.isTitleBorder === true ? 1 : 0}px solid ${customization?.titleBorderColor}`,
                  backgroundColor: customization?.isTitleBorder
                    ? selectedTopId === group.id
                      ? customization?.selectedLevelOneBackgroundColor
                      : customization?.titleBackgroundColor
                    : 'transparent',
                  padding: customization?.isTitleBorder === true ? customization?.titlePadding : '0px',
                  borderRadius: customization?.isTitleBorder === true ? customization?.titleBorderRadius : '0px',
                  color:
                    selectedTopId === group.id
                      ? customization?.selectedLevelOneTextColor
                      : customization?.levelOneTextColor,
                }}
              >
                {group.title}
              </div>
            ))}
          </div>

          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              gap: 10,
              padding: 10,
            }}
          >
            {/* {customization.items
              .find(group => group.id === selectedTopId)
              ?.children.map((child, idx) => (
                <div
                  key={idx}
                  onClick={() => setSelectedCategoryId(child.categoryId)}
                  style={{
                    cursor: 'pointer',
                  }}
                >
                  <div
                    style={{
                      border: `1px solid ${
                        selectedCategoryId === child.categoryId
                          ? customization?.selectedLevelTwoBorderColor
                          : 'transparent'
                      }`,
                      width: 'max-content',
                      padding: '5px',
                    }}
                  >
                    <img
                      src={child?.image ? child?.image : process.env.REACT_APP_LOGO}
                      style={{
                        width: staticValues[60],
                        height: staticValues[60],
                      }}
                    />
                  </div>
                  <div
                    className="line-clamp-2"
                    style={{
                      width: staticValues[60],
                      fontSize: customization?.levelTwoTextSize,
                      fontWeight: customization?.levelTwoTextWeight,
                      color:
                        selectedCategoryId === child.categoryId
                          ? customization?.selectedLevelTwoTextColor
                          : customization?.levelTwoTextColor,
                    }}
                  >
                    {child?.title}
                  </div>
                </div>
              ))} */}
            {/* {customization.items.find(group => group.id === selectedTopId)?.children.length > 1 &&
              customization.items
                .find(group => group.id === selectedTopId)
                ?.children.map((child, idx) => (
                  <div key={idx} onClick={() => setSelectedCategoryId(child.categoryId)} style={{ cursor: 'pointer' }}>
                    <div
                      style={{
                        border: `1px solid ${
                          selectedCategoryId === child.categoryId
                            ? customization?.selectedLevelTwoBorderColor
                            : 'transparent'
                        }`,
                        width: 'max-content',
                        padding: '5px',
                      }}
                    >
                      <img
                        src={child?.image || process.env.REACT_APP_LOGO}
                        style={{
                          width: staticValues[60],
                          height: staticValues[60],
                        }}
                      />
                    </div>
                    <div
                      className="line-clamp-2"
                      style={{
                        width: staticValues[60],
                        fontSize: customization?.levelTwoTextSize,
                        fontWeight: customization?.levelTwoTextWeight,
                        color:
                          selectedCategoryId === child.categoryId
                            ? customization?.selectedLevelTwoTextColor
                            : customization?.levelTwoTextColor,
                      }}
                    >
                      {child?.title}
                    </div>
                  </div>
                ))} */}
            {(() => {
              const selectedGroup = customization.items.find(group => group.id === selectedTopId);
              const children = selectedGroup?.children || [];
              const shouldRender =
                !customization?.hideIfSingleChildCategory || (children.length && children.length > 1);

              return shouldRender
                ? children.map((child, idx) => (
                    <div
                      key={idx}
                      onClick={() => setSelectedCategoryId(child.categoryId)}
                      style={{ cursor: 'pointer' }}
                    >
                      <div
                        style={{
                          border: `1px solid ${
                            selectedCategoryId === child.categoryId
                              ? customization?.selectedLevelTwoBorderColor
                              : 'transparent'
                          }`,
                          width: 'max-content',
                          padding: '5px',
                        }}
                      >
                        <img
                          src={child?.image || process.env.REACT_APP_LOGO}
                          style={{
                            width: staticValues[60],
                            height: staticValues[60],
                          }}
                        />
                      </div>
                      <div
                        className="line-clamp-2"
                        style={{
                          width: staticValues[60],
                          fontSize: customization?.levelTwoTextSize,
                          fontWeight: customization?.levelTwoTextWeight,
                          color:
                            selectedCategoryId === child.categoryId
                              ? customization?.selectedLevelTwoTextColor
                              : customization?.levelTwoTextColor,
                        }}
                      >
                        {child?.title}
                      </div>
                    </div>
                  ))
                : null;
            })()}
          </div>

          {/* {selectedCategoryId && (
            <div style={{ padding: '10px', fontStyle: 'italic', color: '#555' }}>
              Seçilen Category ID: <b>{selectedCategoryId}</b>
            </div>
          )} */}
        </div>
      )}
      {customization.items?.length > 0 ? (
        <div
          className="`overflow-x-visible relative"
          style={{
            padding: `${customization?.containerPadding}`,
            backgroundColor: customization?.backgroundType === 'backgroundColor' ? customization?.backgroundColor : '',
            backgroundImage:
              customization?.backgroundType === 'backgroundImage' ? `url(${customization?.backgroundImage})` : '',
            backgroundSize: 'cover',
            backgroundPosition: 'center center',
          }}
        >
          <div className={`collection-slider relative `}>
            <div
              style={{
                fontWeight: customization?.textWeight,
                fontStyle: customization?.textStyle,
                fontSize: customization?.textSize,
                color: customization?.textColor,
                textAlign: customization?.textAlignment,
                letterSpacing: customization?.textLetterSpacing,
              }}
            >
              {item?.data?.text}
            </div>

            <div className="collection--slider flex flex-col">
              <InfiniteSlider
                activeAnimationCoefficient={1}
                pausedAnimationCoefficient={1}
                forceReset={reset}
                sliderId={item?.id}
                isCentered={isCentered}
                activeBigger={activeBigger}
                classNames={{
                  SliderItemWrapper: 'image-wrapper pr-2 flex flex-col min-w-full',
                }}
                styles={{
                  SliderItemWrapper: {
                    display: 'flex',
                    minWidth: imageWidth + '%',
                    maxWidth: imageWidth + '%',
                    height: 'auto',
                    wordSpacing: `${customization?.textWordSpacing}px`,
                    letterSpacing: `${customization?.textLetterSpacing}px`,
                  },
                }}
              >
                {renderImages}
              </InfiniteSlider>
            </div>
          </div>
        </div>
      ) : (
        <img src={item?.placeholderImage} className={` w-full `} />
      )}
    </>
  );
}

export default BaseFilteredProductSlider;
